import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { API } from './../../app.api';
import { StorageService } from './localsorage.service';
import { Roles } from './role';
import { UserLogin } from './user';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  helper = new JwtHelperService();
  private _user?: UserLogin;

  constructor(
    private http: HttpClient,
    private router: Router,
    private localstorageService: StorageService
  ) { }


  isLoggedIn(): boolean {
    if (this.localstorageService.getLocalStorage("user_jesus_app")) {
      return true
    }
    return false
  }

  login(body: any): Observable<UserLogin> {
    return this.http.post(`${API}/sessions`, body)
      .pipe(tap((user: UserLogin) => {
        this._user = user
        this.initUser(user)
      }))
  }

  logout() {
    this.localstorageService.removeLocalStorage("user_jesus_app")
    delete this._user;
    void this.router.navigate(['/portal'])
  }

  private initUser(response: any) {
    this._user = response;
    this.localstorageService.setLocalStorage("user_jesus_app", this._user)
  }

  registerUser(body: any): Observable<any> {
    return this.http.post(`${API}/users`, body)
  }

  forgotPassword(email: any): Observable<any> {
    return this.http.post(`${API}/password-recoveries/generate-reset-token`, email)
  }

  forgotPasswordToken(body: any): Observable<any> {
    return this.http.post(`${API}/password-recoveries/reset-password`, body)
  }

  private isValid() {
    return !!this.user;
  }

  get user() {
    if (this._user === undefined && this.localstorageService.getLocalStorage("user_jesus_app") != null) {
      this._user = this.localstorageService.getLocalStorage("user_jesus_app");
    }
    return this._user;
  }

  getTokenExpired() {
    return this.helper.isTokenExpired(this.token?.toString())
  }

  get token() {
    return this.isValid() && this.user?.token;
  }

  get nameUser() {
    return this.isValid() && this.user?.user.userName;
  }

  get image() {
    return this.isValid() && this.user?.user.profile.image;
  }

  get isAdmin() {
    return this.isValid() && this.user?.user.role.name == Roles.ADMIN;
  }

  get isUser() {
    return this.isValid() && this.user?.user.role.name == Roles.USER;
  }

  get isAssociate() {
    return this.isValid() && this.user?.user.role.name == Roles.ASSOCIATE;
  }

}
